var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkBlackBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#1C1C20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6671 16.3334C14.9557 17.622 17.0451 17.622 18.3337 16.3334L21.6671 13C22.9558 11.7114 22.9557 9.62201 21.6671 8.33334C20.3784 7.04467 18.2891 7.04467 17.0004 8.33334L15.3337 10",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3334 13.6666C15.0448 12.378 12.9554 12.378 11.6668 13.6666L8.33341 17C7.04474 18.2886 7.04474 20.378 8.33341 21.6667C9.62208 22.9553 11.7114 22.9553 13.0001 21.6667L14.6668 20",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBlackBg);
export default __webpack_public_path__ + "static/media/LinkBlackBg.dc8a1372182031229dc9fb19bf07ec1d.svg";
export { ForwardRef as ReactComponent };